<template>
	<div class="col-sm-12 col-lg-3">
		<div>
			<input class="filter filter__distance city-input"
			       v-model="city.distance"
			       type="number"
			       min="0"
			       :placeholder="`${$t('filters.distance')} (km)`"
			>

			<span v-if="city.distance" class="filter__distance--span filter__distance--km">km</span>
			<span class="filter__distance--span">{{ $t('filters.distanceFrom') }}</span>

			<input type="text"
				   ref="autocomplete"
				   class="filter__city city-input"
				   placeholder="city"
			>
		</div>
	</div>
</template>

<script>
	/* global google */
	import { mapActions, mapMutations } from 'vuex'

	export default {
		props: [
			'name'
		],
		data () {
			return {
				showList: '',
				searchByCity: '',
				city: {
					distance: '',
					point: '',
					name: ''
				}
			}
		},
		methods: {
			...mapActions(['fetchEvents']),
			...mapMutations(['setCities', 'allowLocation']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFiltersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			getCities (item) {
				this.setCities(item)
				this.fetchEvents()
			},
			selectPlace (place) {
				const ac = place.address_components
				this.city.point = `${ place.geometry.location.lat() },${ place.geometry.location.lng() }`
				this.city.name = ac[0]['short_name']
				this.getCities(this.city)
			},
			clearData () {
				this.city.name = ''
				this.city.point = ''
				this.city.distance = ''
			}
		},
		watch: {
			'$store.state.events.activeCity' (val) {
				if (val === '') {
					this.clearData()
				}
			},
			'$store.state.events.distance' (val) {
				if (val === '') {
					this.clearData()
				}
			},
			'city.distance' () {
				this.getCities(this.city)
			}
		},
		mounted () {
			const options = {
				types: [
					'(cities)'
				]
			}
			this.autocomplete = new google.maps.places.Autocomplete(
				(this.$refs.autocomplete),
				options
			)
			this.autocomplete.addListener('place_changed', () => {
				const place = this.autocomplete.getPlace()
				this.selectPlace(place)

				this.city.distance = this.city.distance || '100'
			})

			if (!this.$store.state.events.point) {
				navigator.geolocation.getCurrentPosition(({ coords }) => {
					const latLng = { lat: coords.latitude, lng: coords.longitude }
					const geocoder = new google.maps.Geocoder()
					geocoder.geocode({ location: latLng }, (result, status) => {
						if (status !== 'OK' || !result[3]) return
						this.allowLocation()
						this.$refs.autocomplete.value = result[3].formatted_address
						this.selectPlace(result[3])
					})
				})
			}
		},
		created () {
			window.addEventListener('click', this.closeFiltersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFiltersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";

	.city-input {
		cursor: text;
	}

	.filter {
		&__city {
			font-size: 14px;
			height: 40px;
			position: absolute;
			max-width: 105px;
			top: 0;
			right: 15px;
			border: none;
			outline: none;
			text-align: center;
		}

		&__distance {
			-moz-appearance:textfield;

			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}

			&--span {
				position: absolute;
				top: 12px;
				left: 45%;
				font-size: 14px;
			}

			&--km {
				left: 36%;
			}
		}
	}

	@media (max-width: 991.98px) {
		.filter {
			&__city {
				max-width: 130px;
			}

			&__distance {
				&--span {
					left: auto;
					right: 150px;
				}

				&--km {
					right: 187px;
				}
			}
		}
	}

	@media (max-width: 320px) {
		.filter {
			&__city {
				max-width: 100px;
			}

			&__distance {
				&--span {
					left: auto;
					right: 120px;
				}

				&--km {
					right: 155px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/DistanceFilterComponent.vue